export const couponMoldTypeToText = (couponMoldType) => {
    if (couponMoldType === 'FIX') {
        return '원'
    } else {
        return '%'
    }
};
